module.exports = __webpack_public_path__ + "static/livesync_player_content_drop-230d814a5f8885939ba1e0bd67118515.png";